import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=75e5298f&scoped=true&"
var script = {}
import style0 from "./SectionHeader.vue?vue&type=style&index=0&id=75e5298f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e5298f",
  null
  
)

export default component.exports